import { Logo } from '../logo'
import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $tgAccuntData } from '@/entities/user'
import { lang } from '@/shared/constants/lang.tsx'
import dizzaractLogo from 'public/assets/temp/dizzaract.svg'

type LoadingScreenProps = {
  visible: boolean,
}
export const LoadingScreen = ({ visible }: LoadingScreenProps) => {
  const { classes } = useStyles({})
  const userLang = useUnit($tgAccuntData)?.user?.language_code
  const text = userLang ? lang[userLang === 'ru' ? 'ru' : 'en'].loading_screen.text : ''

  return (
    <div
      data-visible={visible}
      className={classes.root}
    >
      <div className={classes.gamedContainer}>
        <Logo />
        <div className={classes.text}>{text}</div>
      </div>
      <div className={classes.dizzaractContainer}>
        <div>Powered by</div>
        <img src={dizzaractLogo} alt='Dizzart' />
      </div>
    </div>
  )
}
